import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

export default function ButtonCollapse({ templateId }) {
  return (
    <div className="btn-collapse">
      <Button
        variant="link"
        className="collapsed"
        data-bs-toggle="collapse"
        data-bs-target={`.${templateId}`}
        aria-expanded="false"
      />
    </div>
  );
}

ButtonCollapse.propTypes = {
  templateId: PropTypes.string.isRequired,
};
